import {
  Component,
  HostBinding,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  faBars,
  faEuroSign,
  faFileAlt,
  faPlay,
  faPlus,
  faSpinner,
} from '@fortawesome/pro-solid-svg-icons';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  ArztDatenResponseMitInputForm,
  ClientService,
  PreviewResponse,
} from '../api/client.service';
import { Store } from '@ngrx/store';
import { AppToastService } from '../../toast/app-toast.service';
import { StepperComponent } from '../../shared/stepper/stepper.component';
import { StepComponent } from '../../shared/stepper/step/step.component';
import { BehaviorSubject, interval, Observable, Subscription } from 'rxjs';
import { HideCustomLogoAction } from '../../reducers/header.reducer';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import {
  ComponentCanDeactivate,
  gueltigeKVNR,
  noFutureDate,
} from '../../shared/form-helpers';
import { InfotextArztdatenQRTNEComponent } from './infotext-arztdaten-qrtne/infotext-arztdaten-qrtne.component';
import { HttpErrorResponse } from '@angular/common/http';

function newForm() {
  return new FormGroup({
    versicherten_nummer: new FormControl(null, [
      Validators.required.bind(Validators),
      gueltigeKVNR,
    ]),
    vorname: new FormControl(null, [Validators.required.bind(Validators)]),
    nachname: new FormControl(null, [Validators.required.bind(Validators)]),
    geschlecht: new FormControl(null, [Validators.required.bind(Validators)]),
    geburtsdatum: new FormControl(null, [
      Validators.required.bind(Validators),
      noFutureDate,
    ]),
    krankenkasse: new FormControl(null, [Validators.required.bind(Validators)]),
    email: new FormControl(null, [
      Validators.required.bind(Validators),
      Validators.email.bind(Validators),
    ]),
  });
}

@Component({
  selector: 'san-qrtnedaten-eingabe',
  templateUrl: './qrtnedaten-eingabe.component.html',
  styleUrls: ['./qrtnedaten-eingabe.component.scss'],
  standalone: false,
})
export class QRTNEDatenEingabeComponent
  implements OnInit, OnDestroy, ComponentCanDeactivate
{
  @HostBinding('class.d-block') dblock = true;
  @HostBinding('class.h-100') h100 = true;

  @ViewChild('stepperComponent') stepperComponent: StepperComponent;
  // Steps:
  @ViewChild('stepLogin') stepLogin: StepComponent;
  @ViewChild('stepZustimmung') stepZustimmung: StepComponent;
  @ViewChild('stepZustimmungBestaetigung')
  stepZustimmungBestaetigung: StepComponent;
  @ViewChild('stepZustimmungBestaetigungNachLogin')
  stepZustimmungBestaetigungNachLogin: StepComponent;
  @ViewChild('stepWiderruf') stepWiderruf: StepComponent;
  @ViewChild('stepWiderrufBestaetigung')
  stepWiderrufBestaetigung: StepComponent;
  @ViewChild('stepUngueltigeEinschreibung')
  stepUngueltigeEinschreibung: StepComponent;
  @ViewChild('infotextArztdatenQRTNEComponent')
  infotextArztdatenQRTNEComponent: InfotextArztdatenQRTNEComponent;
  @ViewChild('stepFehlerNichtEingeschrieben')
  stepFehlerNichtEingeschrieben: StepComponent;
  @ViewChild('stepTnz') stepTNZBEginn: StepComponent;
  @ViewChild('stepBasisdatenZwei') stepBasisDatenZwei: StepComponent;

  spinnerIcon = faSpinner;
  iconAdd = faPlus;
  iconStart = faPlay;
  iconBars = faBars;
  iconEuros = faEuroSign;
  iconDokumente = faFileAlt;

  environment = environment;
  datenschutzAkzeptiert = false;
  loading = false;

  sending = false;
  wrongCredentials = false;

  arztDatenResponseMitInputForm: ArztDatenResponseMitInputForm = {
    input_form: newForm(),
    arzt: null,
    vertrag: null,
    krankenkassen: [],
    vertrag_name: '',
    tnzCheck$: new BehaviorSubject<{
      ae: Date;
      vertrag: Date;
      kkBeitritt: Date;
    } | null>(null),
  };

  state: PreviewResponse;

  showLinkToWiderruf = true;
  test = new FormControl('', [Validators.required.bind(Validators)]);

  // tslint:disable-next-line:variable-name
  tnz_beginn = '';
  // tslint:disable-next-line:variable-name
  tnz_form = new FormGroup({
    tnz_beginn: new FormControl('', [
      Validators.required.bind(Validators),
      this.badTimeValidator.bind(this),
    ]),
  }); // TODO: custom validator for bad time
  userParams: {
    tnz_beginn: string;
    uuid: string;
    versorgungsVertragID: number;
    vertragsgruppe: number;
    action?: string;
  } = {
    tnz_beginn: '',
    versorgungsVertragID: 0,
    vertragsgruppe: 0,
    uuid: '',
    action: '',
  };
  krankenkassen: { name: string; id: number }[] = [];
  login = false;
  previewState: PreviewResponse;
  creds: {
    versicherten_nummer: string;
    geburtsdatum: string;
    tnz_beginn: string;
  } = null;
  issue = 0;
  private interval: Observable<number>;
  private intervalSub$: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiClient: ClientService,
    private store: Store,
    private toastService: AppToastService,
    private router: Router,
  ) {
    // noinspection PointlessArithmeticExpressionJS
    this.interval = interval(1 /* min */ * 2 /* s */ * 1000 /* ms */);
  }

  ngOnDestroy(): void {
    this.intervalSub$?.unsubscribe();
    this.store.dispatch(new HideCustomLogoAction());
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((value: Params) => {
      this.userParams.uuid = value.uuid as string;
      this.userParams.versorgungsVertragID =
        (value.versorgungsvertragId as number) || 0;
      this.userParams.vertragsgruppe = (value.vertragsgruppe as number) || 0;
      this.userParams.action = value.action as string;
      this.userParams.tnz_beginn = value.tnz_beginn as string;
      if (this.userParams.action === 'login') {
        this.login = true;
      }
      setTimeout(() => {
        this.loading = false;
      }, 50);
    });
  }

  badTimeValidator(control: AbstractControl): ValidationErrors {
    const tnzCheck$: BehaviorSubject<{
      ae: Date;
      kkBeitritt: Date;
      vertrag: Date;
    } | null> = this.arztDatenResponseMitInputForm.tnzCheck$;
    const tnzCheck = tnzCheck$.getValue();
    if (!control.value) {
      return null;
    }

    const value = new Date(control.value as string);
    const vertrag = new Date(tnzCheck.vertrag);
    if (vertrag) {
      vertrag.setSeconds(0);
      vertrag.setMinutes(0);
      vertrag.setHours(0);
    }

    const aeValid = new Date(tnzCheck.ae) <= value;
    const kkBeitrittValid = new Date(tnzCheck.kkBeitritt) <= value;

    const tnzNurNachAe =
      !!this.arztDatenResponseMitInputForm?.vertrag?.tnz_nur_nach_ae;

    if (!aeValid && tnzNurNachAe) {
      return { badTime: 'der Arzt Einschreibung' };
    }
    if (!kkBeitrittValid) {
      return { badTime: 'des Krankenkassen Beitritts' };
    }

    return null;
  }

  einschreiben(additionalData: { zustimmungEvaluation: boolean }) {
    if (this.sending) {
      return;
    }

    if (!this.arztDatenResponseMitInputForm.input_form.valid) {
      this.toastService.show(
        'Ein Fehler ist aufgetreten',
        'Ihre Daten enthalten Fehler.',
        'danger',
      );
      return;
    }

    this.sending = true;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const patientenDaten = this.arztDatenResponseMitInputForm.input_form.value;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!Number.isInteger(patientenDaten.krankenkasse)) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
      patientenDaten.krankenkasse = patientenDaten.krankenkasse.id;
    }

    this.apiClient
      .patientenSelbstEinschreibungSignV2({
        patient_akzeptiert_datenschutzbestimmungen: true,
        patient_akzeptiert_sanakeyportal_datenschutzbestimmungen: true,
        patient_akzeptiert_sanakeyportal_nutzungsbedingungen: true,
        patient_akzeptiert_teilnahmebedingungen: true,
        patient_zustimmung_evaluation: additionalData.zustimmungEvaluation,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        patientenDaten,
        uuid: this.userParams.uuid,
        versorgungsvertragId: this.userParams.versorgungsVertragID,
        vertragsgruppe: this.userParams.vertragsgruppe,
        tnz_beginn: this.tnz_beginn,
      })
      .subscribe(
        (value) => {
          this.tnz_beginn = value.beginn_teilnahmezeitraum;
          this.showLinkToWiderruf = false;
          this.stepperComponent.goToStepViaComponent(
            this.stepZustimmungBestaetigung,
            true,
          );
          this.startStatePolling();
        },
        (error: HttpErrorResponse) => {
          this.toastService.show(
            'Ein Fehler ist aufgetreten',
            'Die Einschreibung konnte nicht bestätigt werden. Bitte versuchen Sie es später erneut',
            'danger',
          );
          if (error.status === 404) {
            this.goToErrorArztNichtEingeschrieben();
          } else if (error.status === 418) {
            // TNZ Datum < Datum der Arzt Einschreibung
            this.toastService.show(
              'Ein Fehler ist aufgetreten',
              'Ihr TNZ Beginn ist nicht korrekt. Bitte überprüfen Sie Ihre Eingaben.',
              'danger',
            );
            this.stepperComponent.goToStepViaComponent(
              this.stepTNZBEginn,
              true,
            );
          } else if (error.status === 417) {
            // DigiTNE2 nicht aktiv für Vertrag
            this.toastService.show(
              'Ein Fehler ist aufgetreten',
              'Für die gewählte Krankenkasse ist die Einschreibung nicht möglich.',
              'danger',
            );
          } else if (error.status === 419) {
            // DigiTNE2 nicht aktiv für Vertrag
            this.toastService.show(
              'Ein Fehler ist aufgetreten',
              'Es existiert bereits eine Einschreibung in den Vertrag mit den angegebenen Daten.',
              'danger',
            );
          } else if (error.status === 400) {
            // Fehlerhafte Daten
            // Wenn die Response Daten eine Liste von Strings ist, dann zeige diese String als Fehler an
            if ((error.error as Array<string>).length > 0) {
              this.toastService.show(
                'Ein Fehler ist aufgetreten',
                (error.error as Array<string>).join(', '),
                'danger',
              );
            }
          }
          this.sending = false;
        },
      );
  }

  anmeldenAngeklickt() {
    this.infotextArztdatenQRTNEComponent.ladeArztDaten();
    this.stepperComponent.goToStep(1);
  }

  checkLogin($event: { versicherten_nummer: string; geburtsdatum: string }) {
    const creds = { ...$event, tnz_beginn: this.userParams.tnz_beginn };
    this.apiClient.patientenSelbstEinschreibungPreview(creds).subscribe(
      (value) => {
        this.creds = creds;
        this.state = value;
        this.onSuccessfulLogin();
      },
      (e: HttpErrorResponse) => {
        this.showLoginError(e);
      },
    );
  }

  onSuccessfulLogin() {
    if (this.state.canceled) {
      this.stepperComponent.goToStepViaComponent(
        this.stepWiderrufBestaetigung,
        true,
      );
    } else {
      this.stepperComponent.goToStepViaComponent(
        this.stepZustimmungBestaetigungNachLogin,
        true,
      );
    }
    this.startStatePolling();
  }

  abmelden() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/', 'patientenselbsteinschreibung']);
    });
    this.toastService.show(
      'Abgemeldet',
      'Sie wurden abgemeldet. Bitte schließen Sie diesen Tab/dieses Fenster nun',
      'success',
    );
  }

  widerruf() {
    this.stepperComponent.goToStepViaComponent(this.stepWiderruf, true);
  }

  downloadTNE() {
    this.initCreds();
    this.apiClient
      .patientenSelbstEinschreibungTNE(this.creds)
      .subscribe((value) => {
        this.downloadData(value.b64data, value.filename);
      });
  }

  widerrufBestaetigen() {
    if (this.sending) {
      return;
    }
    this.sending = true;

    this.apiClient.patientenSelbstEinschreibungCancel(this.creds).subscribe(
      () => {
        this.stepperComponent.goToStepViaComponent(
          this.stepWiderrufBestaetigung,
          true,
        );
        this.startStatePolling();
      },
      () => {
        this.toastService.show(
          'Ein Fehler ist aufgetreten',
          'Die Einschreibung konnte nicht widerrufen werden. Bitte versuchen Sie es später erneut',
          'danger',
        );
      },
    );
  }

  goToErrorArztNichtEingeschrieben(issue: number = 0) {
    this.issue = issue;
    this.stepperComponent.goToStepViaComponent(
      this.stepFehlerNichtEingeschrieben,
      true,
    );
  }

  setTnz() {
    this.tnz_beginn = this.tnz_form.get('tnz_beginn').value;
    return true;
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: UIEvent) {
    if (!this.canDeactivate()) {
      $event.returnValue = true;
    }
  }

  canDeactivate(): boolean | Observable<boolean> {
    const changesDone =
      this.tnz_form.dirty ||
      this.arztDatenResponseMitInputForm.input_form.dirty;
    const polling = this.intervalSub$ && !this.intervalSub$.closed;
    return changesDone && !polling;
  }

  arztBestaetigtGeklickt() {
    this.stepperComponent.next();
  }

  zurueck() {
    this.stepperComponent.zurueck();
  }

  zurueckVonError() {
    this.stepperComponent.goToStepViaComponent(this.stepBasisDatenZwei, true);
  }

  vertragGeladen() {
    // this.setTNZValidators(!!this.arztDatenResponseMitInputForm?.vertrag?.tnz_nur_nach_ae);
  }

  private downloadData(pdfb64: string, filename: string) {
    const link = document.createElement('a');
    link.href = `data:application/pdf;base64,${pdfb64}`;
    link.download = filename;
    // this is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      }),
    );

    setTimeout(() => {
      link.remove();
    }, 100);
  }

  private startStatePolling() {
    this.intervalSub$?.unsubscribe();
    this.intervalSub$ = this.interval.subscribe(() => {
      this.refreshState();
    });
  }

  private initCreds() {
    if (!this.creds || !this.creds.tnz_beginn) {
      this.creds = {
        versicherten_nummer: this.arztDatenResponseMitInputForm.input_form.get(
          'versicherten_nummer',
        ).value as string,
        geburtsdatum: this.arztDatenResponseMitInputForm.input_form.get(
          'geburtsdatum',
        ).value as string,
        tnz_beginn: this.tnz_beginn,
      };
    }
  }

  private refreshState() {
    this.initCreds();
    this.apiClient
      .patientenSelbstEinschreibungPreview(this.creds)
      .subscribe((value) => {
        this.previewState = value;
        if (value.teilnahmeerklaerung_abrufbar) {
          this.intervalSub$?.unsubscribe();
        }
      });
  }

  private showLoginError(e: {
    status: number;
    error: { non_field_errors: Array<string> };
  }) {
    if (e.status !== 400) {
      this.toastService.show(
        'Unbekannter Fehler',
        'Ein Unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es später noch mal.',
        'danger',
      );
      return;
    } else if (e.error.non_field_errors[0].endsWith('(Link ungültig)')) {
      this.toastService.show(
        'Link ungültig',
        'Der Zugriff auf die Einschreibung ist nur innerhalb von 14 Tagen möglich,\n' +
          'bitte wenden Sie sich an Ihre behandelnde Arztpraxis.',
        'danger',
      );
      return;
    }
    this.toastService.show(
      'Fehlerhafte Daten',
      'Bitte überprüfen Sie Ihre Daten. Wir konnten keine Einschreibung mit den angegebenen Daten finden.',
      'danger',
    );
  }
}
